import { type ThemeConfig } from '@chakra-ui/react'

// 2. Add your color mode config
export const config: ThemeConfig = {
  initialColorMode: 'dark',
  useSystemColorMode: false,
}